//这个类型 仅为求职课堂的暂时展示形式 后续是否保留 不知 所以写死
import React, { Component } from 'react';
import {goCommonPage,setlog} from '@modules/58m';
export default class CardTextList extends Component {
 goPage(type,index){
    setlog("mchatbot_zhishi_click"+index)
    switch(type){
        case "lie":
        goCommonPage("//zpcommon.58.com/common/m_protect","");
        break;
        case "test":
        goCommonPage("//cvip.58.com/jobDiagnose/index#/");
        break;
        case "safe":
        goCommonPage("//jlwebapp.58.com/cinsurance/homepage/");
        break;
        default:
        return;
    }
 }
 render(){
   return (
        <div className="chatpanel-item chatpanel-item-card-textlist">
            <div className="item-container">
                <div className="item-content">
                    <div className="content-titile">请选择您想了解的知识类型</div>
                    <ul className="content-list-wrap">
                        <li className="content-list-item" onClick={this.goPage.bind(this,'lie',1)}>揭秘招聘常见骗术<span className="iconfont icon-click_guideblack_ic right-arrow"></span></li>
                        {/* <li className="content-list-item" onClick={this.goPage.bind(this,'test')}>测测我的求职实力<span className="iconfont icon-click_guideblack_ic right-arrow"></span></li>
                        <li className="content-list-item" onClick={this.goPage.bind(this,'safe')}>玩赚保险公社，百万保障免费拿<span className="iconfont icon-click_guideblack_ic right-arrow"></span></li> */}
                    </ul>
                </div>
            </div>
        </div>
   )
    }
}